<template>
    <div class="payment-wrapper">
        <div class="payment-header pb-0 px-3 px-lg-0">
            <div class="container">
                <h1 class="payment-title">
                    {{ $t('course_order') }}: {{ course.course }}
                </h1>

                <div class="ui-steeps">
                    <ul class="ui-steeps__header">
                        <li class="ui-steep-header-item is-disabled">
                            <div class="ui-steep-header-item__text">
                                1. {{ $t('order') }}
                            </div>
                        </li>
                        <li class="ui-steep-header-item is-active">
                            <div class="ui-steep-header-item__text">
                                2. {{ $t('payment') }}
                            </div>
                        </li>
                        <li class="ui-steep-header-item is-disabled">
                            <div class="ui-steep-header-item__text">
                                <span class="d-none d-sm-block">3. {{ $t('payment_information') }}</span>
                                <span class="d-block d-sm-none">3. {{ $t('abput_payment') }}</span>
                            </div>
                        </li>
                    </ul>
                </div><!-- /.ui-steeps -->
            </div><!-- /.container -->
        </div>

        <div class="payment-gateway px-3 px-lg-0">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 v-show="flavorConfig.payConfig.yookassa" class="payment-subtitle">
                            {{ $t('safe_payments_notice') }}
                        </h2>

                        <div class="payment-subtitle-notice">{{ $t('we_do_not_store_pay_data') }}</div>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-12 col-lg-6 order-2 order-lg-1 payment-pay-widget-wrapper">
                        <div v-if="!!notification" class="text-center">
                            <span style="color: red;">
                                {{ $t('promocode_failed') }}:<br/> {{ notification }} <br/><br/>
                            </span>
                            {{ $t('promocode_failed_title') }}:
                            <div class="text-left mx-auto" style="width: 70%">
                                <ul>
                                    <li>{{ $t('promocode_failed_1') }};</li>
                                    <li>{{ $t('promocode_failed_2') }};</li>
                                    <li>{{ $t('promocode_failed_3') }}.</li>
                                </ul>
                            </div>
                        </div>

                        <p v-if="discount>0" class="text-center mb-1">
                            {{ $t('promocode_discount', { discount: discount }) }}<br/>
                            <span class="cena">{{ $t('promocode_total_price', { price: price }) }}</span>
                        </p>

                        <pay-widget
                                :item="payItem"
                                @captured="paymentCaptured"
                        />

                    </div>
                    <div class="col-12 col-lg order-1 order-lg-2 mb-lg-0 mb-3">
                        <div class="row d-flex flex-wrap align-items-center">
                            <div class="col-lg-12 col-4 text-lg-right text-center">
                                <img src="poliimg/visa-verified.png" class="img-fluid mb-lg-5">
                            </div>
                            <div v-show="!flavorConfig.payConfig.revolut" class="col-lg-12 col-4 text-lg-right text-center">
                                <img src="poliimg/mir-accept.png" class="img-fluid mb-lg-5">
                            </div>
                            <div class="col-lg-12 col-4 text-lg-right text-center">
                                <img src="poliimg/mastercard-securecode.png" class="img-fluid mb-lg-5">
                            </div>
                        </div>
                    </div>
                </div><!-- /.container -->
            </div>
        </div>

        <div class="payment-course px-3 px-lg-0">
            <div class="container">
                <div v-if="$route.query.hasOwnProperty('addonly')"
                     class="col-12 col-xl-6 offset-xl-3 mt-xl-5 mb-xl-5">
                    <div class="dop-pack-yellow rounded-xl-7 activated">
                        <div class="dop-pack-name">{{ $t('dop_pack_title') }}:</div>
                        <div class="dop-pack-item">{{ $t('dop_pack_item_1') }}</div>
                        <div class="dop-pack-item">{{ $t('dop_pack_item_2') }}</div>
                        <div class="dop-pack-item">{{ $t('dop_pack_item_3') }}</div>
                        <div class="dop-pack-item">{{ $t('dop_pack_item_4') }}</div>
                        <div class="dop-pack-item">{{ $t('dop_pack_item_5') }}</div>
                        <div class="dop-pack-price"
                             v-if="course.additional_package_price">
                            <span class="dop-pack-price-value">{{course.additional_package_price}}</span> <span
                                class="dop-pack-rub">{{ $t('cur') }}</span>
                            <span class="dop-pack-before" v-if="course.additional_package_price_before">{{course.additional_package_price_before}} {{ $t('cur') }}</span>
                        </div>
                    </div>
                </div>
                <course-list-item
                        v-else
                        :course="course"
                        :hideButton="true"
                        :hideAdd="!$route.query.hasOwnProperty('add')"
                        :hideAddSwitch="true"
                        :activated="$route.query.hasOwnProperty('add')"
                />
            </div><!-- /.container -->
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import PayWidget from '@/components/PayWidget.vue'
    import CourseListItem from "./CourseListItem";
    import CStorage from "../data/CStorage";

    export default {
        name: 'payment',
        props: ['idcourse'],
        components: {
            PayWidget,
            CourseListItem,
        },
        data() {
            return {
                course: {},
                loading: false,
                paySystem: 'yookassa',
                notification: '',
                discount: 0,
                price: null,

                payItem: {},

                phone: null,
                comment: null,
            }
        },
        mounted() {
            this.phone = CStorage.popItem('ORD_CUR_phone')
            this.comment = CStorage.popItem('ORD_CUR_comment')

            axios({method: 'get', url: '/courses/' + this.idcourse}).then(response => {
                this.course = response.data
                let price = response.data.price
                let addpack = null
                let partial = null

                if (this.$route.query.hasOwnProperty('add')) {
                    price = response.data.full_price;
                    addpack = 'add';
                }
                if (this.$route.query.hasOwnProperty('addonly')) {
                    price = response.data.additional_package_price;
                    addpack = 'addonly';
                }
                if (this.$route.query.hasOwnProperty('partial')) {
                    price = response.data.partial_pay_amount;
                    partial = true;
                }

                let client_id = ''
                if (this.$metrika && this.$metrika.getClientID()) client_id = this.$metrika.getClientID()

                const recurrent = (this.$route.query.recurrent === true || this.$route.query.recurrent === 'true')

                const params = {
                    confirmation_type: 'embedded',
                    promocode: this.$route.query.promocode,
                    recurrent: recurrent,
                    price: price,
                    addpack: addpack,
                    description: response.data.course,
                    idcourse: response.data.idcourse,
                    client_id: client_id,
                    phone: this.phone,
                    comment: this.comment,
                    partial: partial,
                }

                axios({method: 'post', url: '/payment', data: params}).then(payresponse => {
                    console.log(payresponse.data)
                    if (payresponse.data.log && payresponse.data.log.length) this.notification = payresponse.data.log.join('<br/>')
                    this.price = payresponse.data.userpayment.price
                    if (partial)
                        this.discount = this.course.partial_pay_amount - payresponse.data.userpayment.price
                    else
                        this.discount = this.course.price - payresponse.data.userpayment.price

                    if (payresponse.data.userpayment.price <= 0) {
                        this.$router.push('/paymentstatus/free?idcourse=' + this.idcourse)
                    }

                    this.payItem = {
                        user_payment_id: payresponse.data.userpayment.id,
                        confirmation_type: 'embedded',
                        promocode: this.$route.query.promocode,
                        recurrent: recurrent,
                        price: this.price,
                        addpack: addpack,
                        description: response.data.course,
                        idcourse: response.data.idcourse,
                        client_id: client_id,
                        paypalClientId: payresponse.data.paypal_client_id,
                        phone: this.phone,
                        comment: this.comment,
                    }

                    window.dataLayer.push({
                        "ecommerce": {
                            "purchase": {
                                "actionField": {
                                    "id": "ORDER_COURSE_" + this.course.idcourse
                                },
                                "products": [
                                    {
                                        "id": this.course.idcourse,
                                        "name": this.course.course,
                                        "price": price,
                                        "brand": "Полиглотики",
                                        "category": "Курс",
                                        "coupon": this.$route.query.promocode,
                                        "position": this.course.pos,
                                    },
                                ]
                            }
                        }
                    });
                })
            })

            this.loading = false
        },

        methods: {
            paymentCaptured(data) {
                this.$router.push('/paymentstatus/' + this.payItem.user_payment_id)
            },

            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },
        }
    };
</script>
<style src="@/assets/hometeacher/css/main.css">
</style>
